import { ChangeDetectionStrategy, Component, Input, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { Theme } from '@ninety/platform/models/enums/theme';
import { ErrorService, SessionService } from '@ninety/platform/services';
import { CompanyUserListModel } from '@ninety/platform/state';
import {
  selectActiveCompanyUsers,
  selectAllCompanyUsers,
  selectCurrentCompanyUser,
  selectInactiveCompanyUsers,
} from '@ninety/platform/state/app-entities/company-users/company-users-state.selectors';
import { TerraDividerModule, TerraSelectModule } from '@ninety/terra';
import { SearchCompanyFilterPipe } from '@ninety/ui/core';

import { CompanyLogoComponent } from '../company-logo/company-logo.component';

@Component({
  selector: 'ninety-company-menu',
  templateUrl: './company-menu.component.html',
  styleUrls: ['./company-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CompanyLogoComponent,
    SearchCompanyFilterPipe,
    LetDirective,
    TerraDividerModule,
    TerraSelectModule,
    FormsModule,
    MatTooltipModule,
  ],
})
export class CompanyMenuComponent {
  sessionService = inject(SessionService);
  private store = inject(Store);
  private errorService = inject(ErrorService);

  protected companySearch = '';

  protected readonly unreachableTooltip = "You can't switch to this company with your current sign-in method.";

  @Input() isSidenavExpanded: boolean;
  @Input() theme: Theme;
  protected Theme = Theme;

  public activeCompanyUsers$ = this.store.select(selectActiveCompanyUsers);
  public inactiveCompanyUsers$ = this.store.select(selectInactiveCompanyUsers);
  public allCompanyUsers$ = this.store.select(selectAllCompanyUsers);
  public currentCompanyUser$ = this.store.select(selectCurrentCompanyUser);

  protected isSelectOpen = signal(false);

  switchCompany(company: CompanyUserListModel): void {
    try {
      this.sessionService.switchCompany(company);
    } catch (error) {
      this.errorService.notify(
        error,
        'There was an error switching companies, please try again or contact customer support.',
        'CompanyMenuComponent: switchCompany'
      );
    }
  }

  protected compareByCompanyId = (a: CompanyUserListModel, b: CompanyUserListModel) => a?.companyId === b?.companyId;

  protected selectOpenChanged(isOpen: boolean) {
    this.isSelectOpen.set(isOpen);
  }
}
